import React from 'react';
import { Formik, Form as FormikForm } from 'formik';

const Form = FormikForm as unknown as React.ComponentType<
  React.PropsWithChildren<Record<string, unknown>>
>;

import { getTranslation } from 'helpers/getTranslation';

import { Drawer } from 'components/shared/Drawer';
import { Button } from 'components/shared/Button';
import { Loading } from 'components/shared/Loading';

import { FormikField } from 'components/FormikField';
import { SelectField, InputField } from 'components/FormikFields';

import { getPlatformOptions } from './CreateDailyChallenge.config';

import {
  initialValues,
  getValidationSchema,
} from './CreateDailyChallenge.formConfig';

import styles from './CreateDailyChallenge.module.scss';

const CreateDailyChallenge = ({
  open,
  createLoading,
  schoolOptions,
  onClose,
  onCreateClick,
}: {
  open: any;
  createLoading: any;
  schoolOptions: any;
  onClose: any;
  onCreateClick: any;
}) => (
  <Drawer
    open={open}
    headerContent="Create Daily Challenge"
    onClose={onClose}
  >
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={getValidationSchema()}
      onSubmit={onCreateClick}
    >
      <Form className={styles.form}>
        <div className={styles.inner}>
          <FormikField
            name="platform"
            component={SelectField}
            componentProps={{ options: getPlatformOptions() }}
            controlProps={{
              required: true,
              label: getTranslation(
                'trainings_page.create_training.platform_label',
              ),
            }}
          />
          <FormikField
            name="school"
            component={SelectField}
            componentProps={{
              options: schoolOptions,
            }}
            controlProps={{
              required: true,
              label: getTranslation(
                'trainings_page.create_training.school_label',
              ),
            }}
          />
          <FormikField
            name="scheduledDay"
            component={InputField}
            componentProps={{
              type: 'date',
            }}
            controlProps={{
              label: 'Scheduled day (UTC)',
            }}
          />
        </div>
        <div className={styles.actions}>
          <Button
            className={styles.action}
            size="md"
            variant="outlined"
            onClick={onClose}
          >
            {getTranslation('common.button.cancel')}
          </Button>
          <Button
            className={styles.action}
            startIcon={
              createLoading && <Loading color={'var(--color-white-primary)'} />
            }
            type="submit"
            size="md"
          >
            {getTranslation('common.button.create')}
          </Button>
        </div>
      </Form>
    </Formik>
  </Drawer>
);

export default React.memo(CreateDailyChallenge) as any;
